import { tns } from 'tiny-slider/src/tiny-slider'
import '../libs/swiper-bundle.min.js';

const videoSliders = document.querySelectorAll('.block-video-slider .slides')
const blockGallerySliders = document.querySelectorAll('.acf-gallery .slides');
const quoteSliders = document.querySelectorAll('.block-quote-slider .slides')

function initSliders() {
	if (videoSliders && videoSliders.length > 0) {
		videoSliders.forEach(sliderEl => {
			let controls = sliderEl.parentElement.querySelector('.custom-controls')
			let slider = tns({
				container: sliderEl,
				autoplay: false,
				nav: false,
				controls: true,
				center: true,
				gutter: 15,
				prevButton: controls.querySelector('.prev'),
				nextButton: controls.querySelector('.next'),
			})

			//Pauses video in previous slide when slide changes
			slider.events.on('transitionStart', function () {
				let info = slider.getInfo()
				let videoElement = info.slideItems[info.indexCached].querySelector('video')
				if (videoElement) {
					videoElement.pause()
				}
			})
		})
	}
	if (blockGallerySliders && blockGallerySliders.length > 0) {
		blockGallerySliders.forEach((sliderEl) => {
			tns({
				container: sliderEl,
				items: 1,
				mode: 'gallery',
				autoplay: false,
				autoplayButtonOutput: false,
				autoHeight: false,
				controls: true,
				nav: true,
				speed: 800,
				controlsPosition: 'bottom'
			})
		})
	}

	if (quoteSliders && quoteSliders.length > 0) {
		smoothscroll.polyfill()
		quoteSliders.forEach((sliderEl) => {
			let controls = sliderEl.parentElement.parentElement.parentElement.parentElement.querySelector('.custom-controls')
			new Swiper(sliderEl.parentElement, {
				cssMode: true,
				mousewheel: true,
				keyboard: true,
				navigation: {
					nextEl: controls.querySelector('.next'),
					prevEl: controls.querySelector('.prev')
				},
				on: {
					slideChange: () => {
						if (sliderEl.querySelector('.read-more')) {
							sliderEl.querySelector('.read-more').style.display = 'block'
							sliderEl.querySelector('.text-expand').style.display = 'none'
							window.scroll({
								behavior: 'smooth',
								top: (sliderEl.getBoundingClientRect().top - 100 - document.body.getBoundingClientRect().top - document.querySelector('#header').clientHeight)
							})
						}
					}
				}
			})
		})
		let readMoreButtons = document.querySelectorAll('.read-more')
		if (readMoreButtons && readMoreButtons.length > 0) {
			readMoreButtons.forEach(btn => {
				btn.addEventListener('click', () => {
					btn.parentElement.querySelector('.text-expand').style.display = 'inline'
					btn.style.display = 'none'
				})
			})
		}
	}
}

export default () => {
	initSliders()
}
